/** Click-to-chat URL that keeps the prefilled text on each platform. */
export function whatsAppShareUrl(phoneDigits: string, message: string, userAgent: string): string {
  const text = encodeURIComponent(message);
  // iOS universal links for wa.me open the chat and drop ?text=.
  if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return `whatsapp://send?phone=${phoneDigits}&text=${text}`;
  }
  return `https://api.whatsapp.com/send?phone=${phoneDigits}&text=${text}`;
}

/** Phones must navigate the current tab. A popup after await is blocked. */
export function shouldOpenWhatsAppInPlace(userAgent: string): boolean {
  return /iPhone|iPad|iPod|Android/i.test(userAgent);
}
